import React from 'react';
import { Download } from '@yme/assets/icons';
import { MiniButton } from '@yme/atoms/mini-button';
export function SpecificationLink({ label, onClickHandler, isVisible, isRightToLeft, }) {
    if (isVisible) {
        return (React.createElement(MiniButton, { iconType: Download, onClick: onClickHandler, isRightToLeft: isRightToLeft }, label));
    }
    return null;
}
SpecificationLink.displayName = 'SpecificationLink_Component';
